import API from '.';

export default class EPSBusinessValueChain {
  /**
   * The epsbusinessline dimension table for UDM
   * @param {number} eps_business_vc_id Id of the epsbusinessline.
   * @param {string} short_description Name of the epsbusinessline.
   * @param {string} long_description Description of the epsbusinessline.
   * @param {number} business_company_id
   */
  constructor({
    eps_business_vc_id,
    short_description,
    long_description,
    business_company_id,
  }) {
    this.eps_business_vc_id = eps_business_vc_id;
    this.short_description = short_description;
    this.long_description = long_description;
    this.business_company_id = business_company_id;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/epsBusinessValueChain');
    return data.map((d) => new EPSBusinessValueChain(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`epsBusinessValueChain/${id}`);
    return new EPSBusinessValueChain(data);
  }

  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('epsBusinessValueChain', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/epsBusinessValueChain`, data);
  //   return res;
  // }
}
